import config from "../../config.json";
import axios from "axios";

export async function getUserAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/user`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getVehicleAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/vehicle`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getExpiryAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/expiry`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}
// Function to delete an alert
export async function deleteAlertById(alertId) {
  const response = await axios.delete(`${config.baseURL}/alert/delete`, {
    data: { id: alertId },
    withCredentials: true,
  });
  return response.data;
}

//function to update the alert 

export async function updateAlert(alertData) {
  try {
    const updatedAlert = await axios.put(
      `${config.baseURL}/alert`,
      alertData,
      { withCredentials: true }
    );

    return updatedAlert.data;
  } catch (error) {
    console.error("Failed to update alert:", error);
    throw error;
  }
}

